import styles from '../../assets/css/redirection.module.css';
import NextButton from '../NextButton';
import { useTranslation } from 'react-i18next';
import { REDIRECT_BUTTON_PREFIX } from '../../utils/translationPagePrefix';

interface RedirectButtonProps {
	onClick(): void;
}

const RedirectButton = ({ onClick }: RedirectButtonProps) => {
	const { t } = useTranslation();

	const text = t(`${REDIRECT_BUTTON_PREFIX}.text`);
	return (
		<div className={styles['redirect-button-container']}>
			<NextButton text={text} onClick={onClick} />
		</div>
	);
};

export default RedirectButton;
